import BaseApiRequest from "./BaseApiRequest";
import { APPLICANT_CREATE_REQUEST_URL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class ApplicantCreateRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = APPLICANT_CREATE_REQUEST_URL;

  constructor(reqData) {
    super();
    this.body = reqData;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
